<div class="row">
	<div class="col-12">
		<h3>Pricing <button class="btn btn-primary btn-sm" (click)="open(addPriceModal)"><i class="ri-add-line"></i></button></h3>

		<table class="table table-borderless">
			<thead>
				<th>Description</th>
				<th>Price</th>
				<th></th>
			</thead>
			<tbody>
				<tr *ngFor="let price of prices">
					<td>{{price.description}}</td>
					<td>{{price.price | currency:'USD'}}</td>
					<td><button class="btn btn-light btn-sm" (click)="open(addPriceModal, price)"><i class="ri-edit-line"></i></button></td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #addPriceModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title" *ngIf="!editMode" >Add price</h4>
		<h4 class="modal-title" id="modal-basic-title" *ngIf="editMode">Edit Price</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<form [formGroup]="form">
			<div class="mb-3">
				<input type="hidden" formControlName="id">
				<label for="">Description</label>
				<input type="text" class="form-control" formControlName="description" [ngClass]="utils.validateInput('description', form)" placeholder="Description">
				<label for="">Price</label>
				<input type="number" class="form-control" formControlName="price" [ngClass]="utils.validateInput('price', form)" placeholder="Price">
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<div class="container">
			<div class="row">
				<div class="col-6" align="left" style="padding-left: 0px;">
					<button type="button" class="btn btn-outline-danger" (click)="deletePrice()" *ngIf="showDeleteBtn()" [disabled]="loading" ><i class="ri-delete-bin-line"></i></button>
				</div>
				<div class="col-6" align="right" style="padding-right: 0px;">
					<button type="button" class="btn btn-outline-secondary" (click)="onSubmit()" *ngIf="!editMode" [disabled]="loading"><i class="ri-add-line"></i>Add</button>
					<button type="button" class="btn btn-outline-secondary" (click)="onSubmit(true)" *ngIf="editMode" [disabled]="loading"><i class="ri-save-2-line"></i>Save</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>
